module.exports = __webpack_public_path__ + "img/Step-3.7a052d5d.jpg";